import styled from '@emotion/styled'
export const StyleTextArea = styled.textarea<any>`
  width: 100%;
  border-radius: 6px;
  padding: 10px;
  height: ${(props) => props.height ?? 300}px;
  min-width: 100%;
  max-width: 100%;
  display: flex;
  resize: none;
  outline: none;
  font-size: 14px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  outline: none;
  &::placeholder {
    font-size: 12px;
    color: ${(props) => props.theme.colors.placeholder};
  }
  ::-ms-input-placeholder {
    color: ${(props: any) => props.theme.colors.grey100};
    font-size: 14px;
  }
  ${(props) => props.styleInput}
`
